module.exports = {

    title: "株式会社M-NET",

    /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
    fixedHeader: false,

    /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
    sidebarLogo: false,
}
